module.exports = __webpack_public_path__ + "img/ble.fd01e7a2.png";